import { createDeviceLinkSupportRequest } from "@/data/requests/supportRequests"
import { useMutation } from "@tanstack/react-query"

export const useCreateDeviceLinkSupportRequestMutation = () =>
  useMutation({ mutationFn: createDeviceLinkSupportRequest })
